module.exports = __webpack_public_path__ + "img/fad-edit.bb0aa86c.svg";